import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Switch from "react-switch";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `roles`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [slug, setSlug] = useState(``);
  const [permissions, setPermissions] = useState(``);
  const [visible, setVisible] = useState("block");
  const [swiched, setSwiched] = useState(false);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const handleSwitch = (checked) => {
    setSwiched(checked);
    setVisible(checked ? "none" : "block");
  };

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.roles_store != undefined && appReducer.roles_store.error == false) ||
        (appReducer.roles_update != undefined && appReducer.roles_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.roles_store,
    appReducer.roles_update
  ])

  useEffect(() => {
    if (appReducer.roles_edit != undefined && id != undefined) {
      let row = appReducer.roles_edit.data;
      setName(row.name);
      setSlug(row.slug);
      setPermissions(row.permissions);
      setVisible(`block`);
      setSwiched(false);
      if (row.permissions.includes("full")) {
        setVisible(`none`);
        setSwiched(true);
      }
    }
  }, [appReducer.roles_edit]);

  useEffect(() => {
    if (appReducer.users_routes_list != undefined) {
      setCategories(appReducer.users_routes_list.data);
    }
  }, [appReducer.users_routes_list]);

  useEffect(() => {
    dispatch(actions.list("users/routes"));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input
      required
      value={name}
      label="نام فارسی"
      name="name"
      type="text"
    />
    <Template.Input
      required
      value={slug}
      label="نام لاتین"
      name="slug"
      type="text"
    />

    <div className="flex flex-col items-start space-y-2">
      <label>همه بخش ها</label>
      <Switch onChange={handleSwitch} checked={swiched} />
    </div>

    {visible == "block" ? (
      <div style={{ display: visible }} className="flex flex-col space-y-5">
        {categories != "" &&
          categories.map((route, r) => {

            let isChecked = false
            if (permissions.includes(route.name)) {
              isChecked = true
            }

            return <div className="flex">
              <input type="checkbox" checked={isChecked} className="shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none" id="hs-checked-checkbox" />
              <label for="hs-checked-checkbox" className="text-sm ms-3">{route.title} - {route.name}</label>
            </div>

          })}
      </div>
    ) : (
      <input type="hidden" name="permissions[]" defaultValue="full" />
    )}

    <Template.Button
      label="ذخیره"
      onClick={handleClick}
    />
  </Template.Form>
};